import styles from './AdditionalOptions.module.css';
import share_icon from '../../../Assets/Images/share_icon.png';
import download_icon from '../../../Assets/Images/download_icon.png';
import treegraph from '../../../Assets/Images/treegraph.png';
import mail_icon from '../../../Assets/Images/mail_icon.png';
import teams_icon from '../../../Assets/svgs/microsoft-teams-svgrepo-com.svg';
import copy_icon from '../../../Assets/svgs/content_copy.svg';
import visual_icon from '../../../Assets/Images/data-visualization.png';
import auto_visualize from '../../../Assets/svgs/auto_visualize.svg';
import bar_chart from '../../../Assets/Images/bar-chart.png';
import pie_chart from '../../../Assets/Images/pie-chart.png';
import line_chart from '../../../Assets/Images/line-chart.png';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import {marked} from 'marked';
import SqlDrawer from './SqlQueryComponent';
import React from 'react';
import {
  Box,
  Menu,
  MenuItem,
  Tooltip,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {callLogEvent} from '../../../Common/Util';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import DWDModal from '../../../Common/Components/DWDModal/DWDModal';

const AdditionalOptions = ({
  msg,
  refId,
  questionRefs,
  setIsPreparingContent,
  handleVisualization,
  handleSavedChats,
  allExpanded,
  setAllExpanded,
  onPrintStart,
  onPrintFinish,
}: any) => {
  // console.log("refId", refId);
  const handlePrint = () => {
    const wrapper = document.createElement('div');
    const clonedRefId = refId.cloneNode(true);
    if (msg.sender !== 'summary') {
      const clonedQuestionId = questionRefs.cloneNode(true);
      clonedQuestionId.style.fontSize = '30px';
      clonedQuestionId.style.padding = '20px';
      wrapper.appendChild(clonedQuestionId);
    }
    wrapper.appendChild(clonedRefId);
    document.body.appendChild(wrapper);
    // html2canvas(wrapper).then((canvas) => {
    //   document.body.removeChild(wrapper); // Clean up after capture
    //   const imgData = canvas.toDataURL("image/png");
    //   const pdf = new jsPDF("p", "mm", "a4");
    //   const imgWidth = 250;
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
    //   pdf.save("download.pdf");
    // });
    // handleClose("download");
  };

  // const handleDownloadAsTextPdf = () => {

  //   if (!refId) {
  //     console.error("Content to download is not available.");
  //     return;
  //   }

  //   const pdf = new jsPDF("p", "mm", "a4");

  //   // 2. Use the .html() method to render the DOM element directly into the PDF
  //   pdf.html(refId, {
  //     callback: function (doc) {
  //       // This function is called when the PDF is ready to be saved
  //       doc.save("chat-summary.pdf");
  //     },
  //     x: 15, // Margin from the left edge of the PDF
  //     y: 15, // Margin from the top edge of the PDF
  //     width: 180, // Sets the content width within the PDF (A4 is 210mm wide)
  //     windowWidth: refId.scrollWidth, // Helps jsPDF calculate the layout based on the element's full width
  //   });

  //   handleClose("download");
  // };
  const handleDataTree = () => {
    try {
      setShowDataTree(true);
      // console.log(showDataTree)
    } catch (e) {
      console.log('Error while opening modal ', e)
    }
  }
  const handleDownloadPdf = async () => {
    console.debug('handleDownloadPdf called', {
      hasMarkdown: !!msg?.chatMessage,
      refId,
    });

    // If the message doesn't have markdown content, try rendering the DOM node (chat) directly.
    if (!msg?.chatMessage) {
      console.debug(
        'No markdown found for message; attempting DOM render fallback'
      );
      let elementToRender: HTMLElement | null = null;

      // Possible shapes for refId: HTMLElement, React ref object with .current, or a selector string
      try {
        if (refId instanceof HTMLElement) {
          elementToRender = refId;
        } else if (
          refId &&
          typeof refId === 'object' &&
          'current' in refId &&
          refId.current instanceof HTMLElement
        ) {
          elementToRender = refId.current;
        } else if (typeof refId === 'string') {
          const queried = document.querySelector(refId);
          if (queried instanceof HTMLElement) elementToRender = queried;
        }
      } catch (e) {
        console.error('Error while determining refId type', e);
      }

      console.debug('elementToRender resolved:', elementToRender);

      if (elementToRender) {
        try {
          const pdf = new jsPDF('p', 'mm', 'a4');
          const margin = 10;
          const pdfWidth = pdf.internal.pageSize.getWidth() - margin * 2;

          const wrapper = document.createElement('div');
          wrapper.style.position = 'absolute';
          wrapper.style.left = '-9999px';
          wrapper.style.top = '0';

          const cloned = elementToRender.cloneNode(true) as HTMLElement;
          wrapper.appendChild(cloned);
          document.body.appendChild(wrapper);

          await new Promise<void>((resolve, reject) => {
            try {
              pdf.html(wrapper, {
                x: margin,
                y: margin,
                html2canvas: {scale: 2, useCORS: true, logging: false},
                width: pdfWidth,
                windowWidth: document.documentElement.scrollWidth,
                callback: (doc) => {
                  try {
                    doc.save('chat.pdf');
                  } catch (e) {
                    console.error('Error saving PDF', e);
                  }
                  if (wrapper && wrapper.parentNode)
                    wrapper.parentNode.removeChild(wrapper);
                  resolve();
                },
              });
            } catch (err) {
              if (wrapper && wrapper.parentNode)
                wrapper.parentNode.removeChild(wrapper);
              reject(err);
            }
          });

          handleClose('download');
          return;
        } catch (err) {
          console.error('Failed to generate PDF from DOM element', err);
          // fall through to markdown flow if available
        }
      }

      console.error(
        'No chat markdown content and no valid DOM reference to render.'
      );
      return;
    }

    const pdf = new jsPDF('p', 'mm', 'a4');
    const margin = 10;
    const pdfWidth = pdf.internal.pageSize.getWidth() - margin * 2;

    const resolveElement = (target: any): HTMLElement | null => {
      try {
        if (target instanceof HTMLElement) return target;
        if (
          target &&
          typeof target === 'object' &&
          'current' in target &&
          target.current instanceof HTMLElement
        ) {
          return target.current;
        }
        if (typeof target === 'string') {
          const queried = document.querySelector(target);
          if (queried instanceof HTMLElement) return queried;
        }
      } catch (e) {
        console.error('Error while resolving chart source element', e);
      }
      return null;
    };

    const appendChartsFromLiveDom = async (
      container: HTMLElement,
      sourceElement: HTMLElement | null
    ) => {
      if (!sourceElement) return;

      const chartNodes = Array.from(
        sourceElement.querySelectorAll('canvas, svg, img')
      ).filter((node) => {
        if (node instanceof HTMLImageElement) {
          const width = node.naturalWidth || node.width || node.clientWidth || 0;
          const height =
            node.naturalHeight || node.height || node.clientHeight || 0;
          return width >= 180 && height >= 120;
        }
        // Skip small SVG icons (like/dislike thumbs etc.) — only keep chart-sized SVGs
        if (node instanceof SVGElement) {
          const rect = node.getBoundingClientRect();
          const w = rect.width || parseFloat(node.getAttribute('width') || '0');
          const h = rect.height || parseFloat(node.getAttribute('height') || '0');
          return w >= 100 && h >= 80;
        }
        return true;
      });

      if (!chartNodes.length) return;

      const chartsWrapper = document.createElement('div');
      chartsWrapper.style.marginTop = '16px';
      chartsWrapper.style.pageBreakInside = 'avoid';

      for (const node of chartNodes) {
        try {
          let chartSrc = '';

          if (node instanceof HTMLCanvasElement) {
            chartSrc = node.toDataURL('image/jpeg', 0.8);
          } else if (node instanceof SVGElement) {
            const svgMarkup = new XMLSerializer().serializeToString(node);
            chartSrc = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
              svgMarkup
            )}`;
          } else if (node instanceof HTMLImageElement) {
            chartSrc = node.currentSrc || node.src || '';
          }

          if (!chartSrc) continue;

          const chartImg = document.createElement('img');
          chartImg.src = chartSrc;
          chartImg.alt = 'chart';
          chartImg.style.display = 'block';
          chartImg.style.width = '320px';
          chartImg.style.maxWidth = '100%';
          chartImg.style.height = 'auto';
          chartImg.style.margin = '10px 0';
          chartsWrapper.appendChild(chartImg);
        } catch (e) {
          console.debug('Failed to append chart image to PDF content', e);
        }
      }

      if (chartsWrapper.childElementCount > 0) {
        container.appendChild(chartsWrapper);
      }
    };

    // Helper that renders an element into the PDF using jsPDF.html and html2canvas with higher scale
    const renderElementToPdf = (el: HTMLElement, filename = 'summary.pdf') => {
      return new Promise<void>((resolve, reject) => {
        try {
          // Ensure element is attached to DOM so computed styles apply
          const wrapper = document.createElement('div');
          wrapper.style.position = 'absolute';
          wrapper.style.left = '-9999px';
          wrapper.style.top = '0';
          wrapper.appendChild(el);
          document.body.appendChild(wrapper);

          pdf.html(wrapper, {
            x: margin,
            y: margin,
            html2canvas: {scale: 2, useCORS: true, logging: false},
            width: pdfWidth,
            windowWidth: document.documentElement.scrollWidth,
            callback: (doc) => {
              try {
                doc.save(filename);
              } catch (e) {
                console.error('Error saving PDF', e);
              }
              // clean up
              if (wrapper && wrapper.parentNode)
                wrapper.parentNode.removeChild(wrapper);
              resolve();
            },
          });
        } catch (err) {
          reject(err);
        }
      });
    };

    try {
      // Robustly extract human-readable markdown text from msg/chat DOM/react nodes
      const extractTextFromNode = (node: any): string => {
        if (node === null || node === undefined) return '';
        if (typeof node === 'string' || typeof node === 'number')
          return String(node);
        if (Array.isArray(node))
          return node.map(extractTextFromNode).join('\n');
        try {
          if (
            (React as any).isValidElement &&
            (React as any).isValidElement(node)
          ) {
            return extractTextFromNode(node.props?.children);
          }
        } catch (e) {
          // ignore
        }
        if (typeof node === 'object') {
          try {
            return JSON.stringify(node, null, 2);
          } catch (e) {
            return String(node);
          }
        }
        return String(node);
      };

      // 1) Prefer explicit string fields
      let markdownString: string = '';
      if (msg) {
        if (
          typeof msg.chatMessage === 'string' &&
          msg.chatMessage.trim() !== ''
        )
          markdownString = msg.chatMessage;
        else if (typeof msg.content === 'string' && msg.content.trim() !== '')
          markdownString = msg.content;
      }

      // 2) Try DOM ref fallback
      if (!markdownString && refId) {
        try {
          let el: any = null;
          if (refId instanceof HTMLElement) el = refId;
          else if (refId && typeof refId === 'object' && 'current' in refId)
            el = refId.current;
          else if (typeof refId === 'string')
            el = document.querySelector(refId);
          if (el instanceof HTMLElement) {
            markdownString = el.innerText || el.textContent || '';
          }
        } catch (e) {
          console.error('Error reading text from refId for pdf', e);
        }
      }

      // 3) Flatten React nodes/arrays
      if (!markdownString && msg && msg.chatMessage) {
        markdownString = extractTextFromNode(msg.chatMessage);
      }

      // 4) Fallback to stringify the whole msg
      if (!markdownString && msg) {
        try {
          markdownString = JSON.stringify(msg, null, 2);
        } catch (e) {
          markdownString = String(msg);
        }
      }

      // Ensure we have a string
      markdownString = String(markdownString || '');

      // Clean common bad-encoded characters and normalize whitespace
      let cleanedMarkdown = markdownString
        .replace(/â€“/g, '-')
        .replace(/âˆ’/g, '-')
        .replace(/â€”/g, '-')
        .replace(/â€™/g, "'")
        .replace(/â€“/g, '-')
        .replace(/âˆ’/g, '-')
        .replace(/â€”/g, '-')
        .replace(/â€™/g, "'")
        .replace(/Ã©/g, 'e')
        .replace(/Ã/gi, 'A')
        .replace(/&nbsp;/g, ' ')
        .replace(/\uFFFD/g, '')
        .replace(/\r\n/g, '\n')
        .replace(/\t/g, ' ')
        .replace(/[ ]{2,}/g, ' ')
        .replace(/\n{3,}/g, '\n\n')
        .trim();

      // Prepare the query content if available
      let questionContent = '';
      if (msg.question) {
        questionContent = `## Query\n\n${msg.question}\n\n## Response\n\n`;
      } else if (questionRefs && questionRefs.textContent) {
        questionContent = `## Query\n\n${questionRefs.textContent}\n\n## Response\n\n`;
      }

      let htmlString = await marked(questionContent + cleanedMarkdown || '');

      // Try to find an images map on the message object similar to RenderSummary.rawText.images
      // Handles both old flat format: { "Section": ["base64", ...] }
      // and new nested format: { "competitor": [{ "Key": "base64" }, ...], "pepsico": [...] }
      const findImagesMap = (m: any): Record<string, string[]> | null => {
        if (!m || typeof m !== 'object') return null;

        // First check standard candidates
        const candidates = [
          m.rawText && m.rawText.images,
          m.images,
          m.summary && m.summary.images,
          m.summaryData && m.summaryData.images,
          m.summary_images,
          m.raw && m.raw.images,
        ];

        for (const c of candidates) {
          if (!c || typeof c !== 'object') continue;

          // Check if this is the new nested format: { "category": [{ "key": value }, ...] }
          const flatMap = flattenNestedImageMap(c);
          if (flatMap) return flatMap;
        }

        // look inside agent_metadata array items
        if (Array.isArray(m.agent_metadata)) {
          for (const item of m.agent_metadata) {
            if (item && typeof item === 'object' && item.images) {
              const flatMap = flattenNestedImageMap(item.images);
              if (flatMap) return flatMap;
            }
          }
        }

        // last-resort: search for an object-valued property
        for (const k of Object.keys(m)) {
          try {
            const val = (m as any)[k];
            if (val && typeof val === 'object') {
              const flatMap = flattenNestedImageMap(val);
              if (flatMap) return flatMap;
            }
          } catch (e) {
            // ignore
          }
        }
        return null;
      };

      // Helper to flatten new nested image structure into flat map for compatibility
      const flattenNestedImageMap = (
        imagesObj: any
      ): Record<string, string[]> | null => {
        if (!imagesObj || typeof imagesObj !== 'object') return null;

        const flattened: Record<string, string[]> = {};
        let hasImages = false;

        for (const key of Object.keys(imagesObj)) {
          const val = imagesObj[key];

          // Old format: direct array of strings (base64 data)
          if (Array.isArray(val)) {
            // Check if it's an array of strings (old format)
            if (val.length > 0 && typeof val[0] === 'string') {
              flattened[key] = val;
              hasImages = true;
            }
            // Check if it's an array of objects (new format: [{ "Key": "data" }, ...])
            else if (val.length > 0 && typeof val[0] === 'object') {
              const imageStrings: string[] = [];
              for (const obj of val) {
                if (typeof obj === 'object') {
                  // Extract all string values from the object (these are the base64/image data)
                  for (const objKey of Object.keys(obj)) {
                    const objVal = obj[objKey];
                    if (typeof objVal === 'string' && objVal.trim()) {
                      imageStrings.push(objVal);
                    }
                  }
                }
              }
              if (imageStrings.length > 0) {
                flattened[key] = imageStrings;
                hasImages = true;
              }
            }
          }
        }

        return hasImages ? flattened : null;
      };

      const imagesMap =
        findImagesMap(msg) || findImagesMap((msg || {}).rawText) || null;
      console.debug(
        '[PDF IMG] imagesMap found:',
        imagesMap ? Object.keys(imagesMap) : 'none'
      );
      if (imagesMap) {
        console.debug(
          '[PDF IMG] flattened image entries:',
          Object.entries(imagesMap).map(([k, v]) => [
            k,
            Array.isArray(v) ? v.length : 0,
          ])
        );
      }

      // Helper to normalize keys (same as RenderSummary)
      const normalizeKey = (s: string) =>
        (s || '').replace(/\s+/g, ' ').trim().toUpperCase();

      if (imagesMap) {
        try {
          // Create a temporary DOM to replace placeholders and img tags
          const tmp = document.createElement('div');
          tmp.innerHTML = htmlString;

          // Replace custom <image>Section</image> placeholders
          const imageTags = Array.from(tmp.getElementsByTagName('image'));
          console.debug('[PDF IMG] found <image> tags:', imageTags.length);
          imageTags.forEach((el) => {
            try {
              const section = (el.textContent || '').trim();
              const key = normalizeKey(section);
              console.debug('[PDF IMG] processing <image> tag:', {
                section,
                normalizedKey: key,
              });
              const matchedKey = Object.keys(imagesMap).find(
                (k) => normalizeKey(k) === key
              );
              if (matchedKey) {
                const imgs = imagesMap[matchedKey] || [];
                console.debug(
                  '[PDF IMG] matched key:',
                  matchedKey,
                  'image count:',
                  imgs.length
                );
                const wrapper = document.createElement('span');
                imgs.forEach((b64, idx) => {
                  const im = document.createElement('img');
                  // Handle both base64 data and full data URL formats
                  if (b64.startsWith('data:')) {
                    im.src = b64;
                  } else {
                    im.src = `data:image/png;base64,${b64}`;
                  }
                  im.alt = section;
                  im.style.maxWidth = '100%';
                  im.style.display = 'block';
                  im.style.marginTop = idx > 0 ? '8px' : '0';
                  wrapper.appendChild(im);
                });
                el.replaceWith(wrapper);
              } else {
                console.debug(
                  '[PDF IMG] no match found for key. Available keys:',
                  Object.keys(imagesMap)
                );
              }
            } catch (e) {
              console.debug('[PDF IMG] error processing <image> tag:', e);
            }
          });

          // For any <img> elements, if src is not a data URL, try to match by alt text
          const imgs = Array.from(tmp.getElementsByTagName('img'));
          console.debug('[PDF IMG] found <img> tags:', imgs.length);
          imgs.forEach((im) => {
            try {
              if (im.src && im.src.startsWith('data:')) return; // already data URL
              const alt =
                im.getAttribute('alt') || im.getAttribute('title') || '';
              const key = normalizeKey(alt);
              let matchedKey: string | undefined = undefined;
              if (key)
                matchedKey = Object.keys(imagesMap).find(
                  (k) => normalizeKey(k) === key
                );
              // if no alt match, try using filename or src as a hint
              if (!matchedKey && im.src) {
                const srcHint = im.src.split('/').pop() || im.src;
                const hintKey = normalizeKey(
                  srcHint.replace(/\.[a-zA-Z0-9]+$/g, '')
                );
                matchedKey = Object.keys(imagesMap).find(
                  (k) => normalizeKey(k) === hintKey
                );
              }
              if (matchedKey) {
                const arr = imagesMap[matchedKey] || [];
                console.debug(
                  '[PDF IMG] img tag matched to key:',
                  matchedKey,
                  'image count:',
                  arr.length
                );
                if (arr.length) {
                  // Replace the original <img> with a wrapper containing all images for the matched key
                  const wrapper = document.createElement('span');
                  arr.forEach((b64, idx) => {
                    const child = document.createElement('img');
                    // Handle both base64 data and full data URL formats
                    if (b64.startsWith('data:')) {
                      child.src = b64;
                    } else {
                      child.src = `data:image/png;base64,${b64}`;
                    }
                    child.alt = im.alt || '';
                    child.style.maxWidth = '100%';
                    child.style.display = 'block';
                    child.style.marginTop = idx > 0 ? '8px' : '0';
                    wrapper.appendChild(child);
                  });
                  im.replaceWith(wrapper);
                }
              }
            } catch (e) {
              // ignore
            }
          });

          htmlString = tmp.innerHTML;
          console.debug('[PDF IMG] htmlString updated with injected images');
        } catch (e) {
          console.debug('[PDF IMG] failed to inject images into htmlString', e);
        }
      }

      // Build a container with CSS to make the PDF readable and closer to RenderSummary styling
      const container = document.createElement('div');
      container.className = 'pdf-export-container';
      const style = `
      <style>
        /* Base */
        .pdf-export-container { font-family: Arial, Helvetica, sans-serif; color: #111; line-height: 1.6; font-size: 12px; box-sizing: border-box; }

        /* Headings */
        .pdf-export-container h1 { font-size: 20px; margin: 24px 0 16px; page-break-after: avoid; }
        .pdf-export-container h2 { font-size: 18px; margin: 20px 0 14px; page-break-after: avoid; }
        .pdf-export-container h3 { font-size: 15px; margin: 16px 0 12px; page-break-after: avoid; }
        .pdf-export-container h4 { font-size: 13px; margin: 14px 0 10px; page-break-after: avoid; }

        /* Paragraphs and lists */
        .pdf-export-container p { margin: 0 0 16px 0; clear: both; }
        .pdf-export-container ul, .pdf-export-container ol { padding-left: 28px; margin: 0 0 16px 0; clear: both; list-style-position: outside; }
        .pdf-export-container li { margin-bottom: 10px; margin-left: 10px; padding-left: 4px; line-height: 1.6; vertical-align: top; font-size: 12px; }
        .pdf-export-container li > p { margin: 0 !important; padding: 0; }
        .pdf-export-container li > p + p { margin-top: 4px !important; }
        .pdf-export-container blockquote { border-left: 3px solid #eee; padding-left: 10px; color: #333; margin: 0 0 16px 0; clear: both; }

        /* SVG icons (thumbs up/down etc.) */
        .pdf-export-container svg { display: inline-block; vertical-align: middle; }

        /* Images */
        .pdf-export-container img { max-width: 100%; height: auto; display: block; margin: 16px 0; clear: both; }

        /* Code and preformatted */
        .pdf-export-container pre { background: #f6f8fa; padding: 12px; overflow: auto; margin: 0 0 16px 0; clear: both; }
        .pdf-export-container code { background: #f6f8fa; padding: 2px 4px; }

        /* Tables */
        .pdf-export-container table {
          border-collapse: collapse;
          width: 100%;
          margin: 20px 0;
          table-layout: fixed;
          word-break: break-word;
          clear: both;
          page-break-inside: avoid;
          background: #fff;
          z-index: 1;
        }
        .pdf-export-container thead {
          display: table-header-group;
          background: #f5f5f5;
        }
        .pdf-export-container tbody {
          display: table-row-group;
        }
        .pdf-export-container th, .pdf-export-container td {
          border: 1px solid #ddd;
          padding: 10px;
          vertical-align: top;
          word-wrap: break-word;
          overflow-wrap: break-word;
          min-width: 50px;
          max-width: none;
        }
        .pdf-export-container th {
          background: #f5f5f5;
          font-weight: 700;
          text-align: left;
          white-space: normal;
        }
        .pdf-export-container tr {
          page-break-inside: avoid;
          background: #fff;
        }
        /* Ensure tables don't overlap with surrounding content */
        .pdf-export-container table:before,
        .pdf-export-container table:after {
          content: "";
          display: block;
          height: 4px;
          visibility: hidden;
          clear: both;
        }

        /* Details/summary and misc */
        .pdf-export-container details { margin: 16px 0; clear: both; }
        .pdf-export-container summary { font-weight: 700; }

        /* Small print adjustments for PDF rendering */
        .pdf-export-container p:first-child { margin-top: 8px; }
        .pdf-export-container { -webkit-print-color-adjust: exact; }
      </style>
    `;
      container.innerHTML = style + htmlString;
      container.style.background = '#ffffff';
      container.style.padding = '8px';
      container.style.boxSizing = 'border-box';

      await appendChartsFromLiveDom(container, resolveElement(refId));

      // Try to compress large inline data-URL images (to reduce PDF size), then
      // inline remote images (convert to data URLs) where possible so html2canvas
      // can capture them even when remote servers support CORS. Then wait for
      // images to finish loading (or timeout) before rendering to canvas.
      const imgs = Array.from(
        container.querySelectorAll('img')
      ) as HTMLImageElement[];

      // Compress large data-URL images to JPEG to reduce size. Parameters can be tuned.
      const compressDataUrlImage = async (
        img: HTMLImageElement,
        maxWidth = 1200,
        quality = 0.8,
        sizeThresholdBytes = 200 * 1024 // 200 KB
      ) => {
        try {
          if (!img.src) return;
          console.debug('[PDF IMG] compressDataUrlImage start', {
            srcStartsWithData: img.src.startsWith('data:'),
            srcLength: img.src.length,
          });
          if (!img.src.startsWith('data:')) return;
          // estimate size of base64 payload
          const comma = img.src.indexOf(',');
          if (comma < 0) return;
          const b64 = img.src.substring(comma + 1);
          // approximate byte length
          const padded = b64.length;
          const approxBytes = Math.ceil((padded * 3) / 4);
          console.debug(
            '[PDF IMG] estimated bytes',
            approxBytes,
            'threshold',
            sizeThresholdBytes
          );
          if (approxBytes <= sizeThresholdBytes) return;

          // load image into an Image object to get natural dimensions
          await new Promise<void>((resolve, reject) => {
            const tmp = new Image();
            tmp.onload = () => resolve();
            tmp.onerror = () => resolve();
            tmp.src = img.src;
            // safety timeout
            setTimeout(() => resolve(), 3000);
          });

          const naturalW = img.naturalWidth || img.width;
          const naturalH = img.naturalHeight || img.height;
          if (!naturalW || !naturalH) return;

          const scale = Math.min(1, maxWidth / naturalW);
          const w = Math.max(1, Math.round(naturalW * scale));
          const h = Math.max(1, Math.round(naturalH * scale));

          const c = document.createElement('canvas');
          c.width = w;
          c.height = h;
          const ctx = c.getContext('2d');
          if (!ctx) return;

          // If image has transparency (PNG), filling with white avoids black bg in JPEG
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(0, 0, w, h);
          ctx.drawImage(img, 0, 0, w, h);

          try {
            const newData = c.toDataURL('image/jpeg', quality);
            if (newData && newData.startsWith('data:')) {
              console.debug(
                '[PDF IMG] compressed data-url length',
                newData.length,
                'original approxBytes',
                approxBytes
              );
              img.src = newData;
            }
          } catch (e) {
            console.debug(
              '[PDF IMG] compress toDataURL failed (possibly tainted canvas)',
              e
            );
            // toDataURL may throw if canvas is tainted - ignore
          }
        } catch (e) {
          // non-fatal
        }
      };

      const inlineImage = async (img: HTMLImageElement) => {
        try {
          if (!img.src) return;
          if (img.src.startsWith('data:')) return; // already inlined

          console.debug('[PDF IMG] inlineImage start', {
            src: img.src && img.src.substring(0, 80),
            naturalWidth: img.naturalWidth,
            naturalHeight: img.naturalHeight,
          });

          // Try to allow cross-origin drawing onto a canvas
          try {
            img.crossOrigin = 'Anonymous';
          } catch (e) {
            // ignore if property cannot be set
          }

          // Wait for image to load (or error)
          await new Promise<void>((resolve) => {
            if (img.complete) return resolve();
            const onDone = () => {
              img.removeEventListener('load', onDone);
              img.removeEventListener('error', onDone);
              resolve();
            };
            img.addEventListener('load', onDone);
            img.addEventListener('error', onDone);
            // safety in case neither event fires
            setTimeout(() => resolve(), 5000);
          });

          // If the image loaded successfully and is drawable, draw it to a canvas
          if ((img.naturalWidth || 0) > 0) {
            try {
              const c = document.createElement('canvas');
              c.width = img.naturalWidth;
              c.height = img.naturalHeight;
              const ctx = c.getContext('2d');
              if (ctx) {
                ctx.drawImage(img, 0, 0);
                // Attempt to export as PNG data URL
                try {
                  const dataUrl = c.toDataURL('image/png');
                  if (dataUrl && dataUrl.startsWith('data:')) {
                    console.debug(
                      '[PDF IMG] inlined remote image to data URL',
                      {length: dataUrl.length}
                    );
                    img.src = dataUrl;
                  }
                } catch (e) {
                  console.debug(
                    '[PDF IMG] toDataURL failed while inlining remote image (tainted?)',
                    e
                  );
                }
              }
            } catch (e) {
              // drawing may fail due to CORS (tainted canvas); ignore and continue
              console.debug(
                '[PDF IMG] drawImage failed while inlining remote image',
                e
              );
            }
          }
        } catch (e) {
          // per-image failure should not block the whole flow
        }
      };

      if (imgs.length > 0) {
        console.debug(
          '[PDF IMG] found images',
          imgs.length,
          imgs.map((i) => ({
            srcStartsWithData: i.src?.startsWith('data:'),
            len: i.src?.length,
            naturalW: i.naturalWidth,
            naturalH: i.naturalHeight,
          }))
        );
        // First, compress large inline data-URL images in parallel (bounded by timeout)
        // For PDF we prefer clarity over aggressive compression: use a larger max width and higher quality
        const pdfPreferredMaxWidth = 2400; // allow large images for better clarity
        const pdfPreferredQuality = 0.95;
        const compressPromises = imgs.map((img) =>
          compressDataUrlImage(
            img,
            pdfPreferredMaxWidth,
            pdfPreferredQuality,
            200 * 1024
          )
        );
        await Promise.race([
          Promise.all(compressPromises),
          new Promise((res) => setTimeout(res, 4000)),
        ]);

        // Then try to inline remote images in parallel but bound the overall wait
        const inlinePromises = imgs.map((img) => inlineImage(img));
        // Wait for all attempts or timeout after a short period
        await Promise.race([
          Promise.all(inlinePromises),
          new Promise((res) => setTimeout(res, 7000)),
        ]);

        // Now ensure images are loaded (or at least attempted) before capture
        await new Promise<void>((resolve) => {
          let counter = 0;
          const check = () => {
            counter++;
            if (counter >= imgs.length) resolve();
          };
          imgs.forEach((img) => {
            if (img.complete) check();
            else {
              const onDone = () => {
                img.removeEventListener('load', onDone);
                img.removeEventListener('error', onDone);
                check();
              };
              img.addEventListener('load', onDone);
              img.addEventListener('error', onDone);
            }
          });
          // safety timeout
          setTimeout(() => resolve(), 7000);
        });
        console.debug(
          '[PDF IMG] post-processing images',
          imgs.map((i) => ({
            srcStartsWithData: i.src?.startsWith('data:'),
            len: i.src?.length,
            naturalW: i.naturalWidth,
            naturalH: i.naturalHeight,
          }))
        );
      }

      // Append container offscreen so html2canvas can compute layout/styles correctly
      const offscreenWrapper = document.createElement('div');
      offscreenWrapper.style.position = 'absolute';
      offscreenWrapper.style.left = '-9999px';
      offscreenWrapper.style.top = '0';
      // Limit width to reasonable max so canvas isn't enormous. We set an initial
      // width but will recompute to fit actual rendered content (tables/images)
      // after the container is inserted into the DOM and images are processed.
      const maxWidth = Math.min(
        document.documentElement.clientWidth || 800,
        900
      );
      container.style.width = maxWidth + 'px';

      // Ensure all details elements are open for PDF capture
      const detailsElements = container.querySelectorAll('details');
      detailsElements.forEach((details) => {
        details.setAttribute('open', 'true');
        details.style.display = 'block';
        details.style.marginBottom = '20px';
      });
      // Additional CSS to ensure clean table rendering and prevent overlaps
      const extraCss = document.createElement('style');
      extraCss.innerHTML = `
      /* Adjust table layout so wide tables are captured (don't force 100% width) */
      .pdf-export-container table {
        table-layout: auto !important;
        width: auto !important;
        word-break: break-word !important;
        border-collapse: collapse !important;
        margin: 20px 0 !important;
        page-break-inside: avoid !important;
        clear: both !important;
        position: relative !important;
        z-index: 1 !important;
        overflow: visible !important;
        max-width: none !important;
      }
      .pdf-export-container th, .pdf-export-container td {
        word-break: break-word !important;
        overflow-wrap: anywhere !important;
        padding: 10px !important;
        vertical-align: top !important;
      }
      .pdf-export-container thead {
        display: table-header-group !important;
        background: #f5f5f5 !important;
      }
      .pdf-export-container tr {
        page-break-inside: avoid !important;
        background: #fff !important;
      }
      /* Force spacing between elements */
      .pdf-export-container p { margin: 16px 0 !important; clear: both !important; }
      .pdf-export-container * + table { margin-top: 20px !important; }
      .pdf-export-container table + * { margin-top: 20px !important; }
      .pdf-export-container pre { white-space: pre-wrap !important; }

      /* List alignment */
      .pdf-export-container ul, .pdf-export-container ol { padding-left: 28px !important; list-style-position: outside !important; }
      .pdf-export-container li { padding-left: 4px !important; margin-left: 10px !important; margin-bottom: 10px !important; line-height: 1.6 !important; vertical-align: top !important; font-size: 12px !important; }
      .pdf-export-container li > p { margin: 0 !important; padding: 0 !important; }
      .pdf-export-container li > p + p { margin-top: 4px !important; }

      /* SVG icon sizing for PDF capture */
      .pdf-export-container svg { display: inline-block !important; vertical-align: middle !important; overflow: hidden !important; }

      /* Improve details/summary rendering */
      .pdf-export-container details {
        display: block !important;
        margin: 20px 0 !important;
        padding: 0 !important;
        page-break-inside: avoid !important;
      }
      .pdf-export-container details[open] {
        margin-bottom: 30px !important;
      }
      .pdf-export-container details > * {
        margin-left: 20px !important;
      }
      .pdf-export-container details > summary {
        margin-left: 0 !important;
        font-weight: bold !important;
        margin-bottom: 10px !important;
        display: block !important;
      }
      /* Ensure proper spacing between sections */
      .pdf-export-container details + details { margin-top: 30px !important; }
      .pdf-export-container table + details, .pdf-export-container details + table { margin-top: 30px !important; }
      .pdf-export-container h1 + details, .pdf-export-container h2 + details, .pdf-export-container h3 + details { margin-top: 20px !important; }
      .pdf-export-container details + h1, .pdf-export-container details + h2, .pdf-export-container details + h3 { margin-top: 30px !important; }
    `;
      container.insertBefore(extraCss, container.firstChild);

      offscreenWrapper.appendChild(container);
      document.body.appendChild(offscreenWrapper);

      // Recompute content width after images & styles applied so wide tables
      // aren't visually squashed. Use the rendered scrollWidth and clamp to a
      // practical maximum to avoid enormous canvases.
      try {
        const computedContentWidth = Math.min(
          Math.max(container.scrollWidth || 0, maxWidth),
          2400
        );
        container.style.width = (computedContentWidth || maxWidth) + 'px';
        // Allow horizontal overflow for html2canvas to capture full width
        container.style.overflowX = 'visible';
        container.style.whiteSpace = 'normal';
      } catch (e) {
        // ignore and fall back to initial width
      }

      // Use html2canvas to capture the container and then add to jsPDF with pagination
      // Use devicePixelRatio for sharper capture on high-DPI screens; clamp to reasonable bounds.
      // IMPORTANT: Dynamically reduce scale if the resulting canvas would exceed browser limits
      // (most browsers cap at ~16384px in any dimension or ~268M total pixels).
      const MAX_CANVAS_DIMENSION = 16384;
      const MAX_CANVAS_PIXELS = 268000000; // ~268 million pixels
      const contentWidth = container.scrollWidth || maxWidth;
      const contentHeight = container.scrollHeight || 800;
      let dpr = Math.max(1, Math.min(3, window.devicePixelRatio || 2));

      // Reduce scale if canvas would exceed dimension or total pixel limits
      const maxScaleByWidth = MAX_CANVAS_DIMENSION / contentWidth;
      const maxScaleByHeight = MAX_CANVAS_DIMENSION / contentHeight;
      const maxScaleByPixels = Math.sqrt(MAX_CANVAS_PIXELS / (contentWidth * contentHeight));
      const safeScale = Math.min(dpr, maxScaleByWidth, maxScaleByHeight, maxScaleByPixels);
      dpr = Math.max(1, safeScale); // never go below 1

      console.debug('[PDF] canvas dimensions check', {
        contentWidth,
        contentHeight,
        devicePixelRatio: window.devicePixelRatio,
        finalScale: dpr,
        estimatedCanvasW: Math.round(contentWidth * dpr),
        estimatedCanvasH: Math.round(contentHeight * dpr),
      });

      let canvas = await html2canvas(container, {
        scale: dpr,
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
      });

      // Safety check: if canvas produced is empty/black (width or height is 0,
      // or total pixels is suspicious), retry with scale=1
      if (!canvas.width || !canvas.height) {
        console.warn('[PDF] html2canvas produced empty canvas, retrying with scale=1');
        canvas = await html2canvas(container, {
          scale: 1,
          useCORS: true,
          logging: false,
          backgroundColor: '#ffffff',
        });
      }

      // Use JPEG output with quality to reduce file size
      const imgData = canvas.toDataURL('image/jpeg', 0.8);

      const pdfPageWidth = pdf.internal.pageSize.getWidth() - margin * 2;
      const pdfPageHeight = pdf.internal.pageSize.getHeight() - margin * 2;

      const imgWidth = canvas.width;
      const imgHeight = canvas.height;

      const renderedImgHeight = (imgHeight * pdfPageWidth) / imgWidth; // height in PDF units

      if (renderedImgHeight <= pdfPageHeight) {
        pdf.addImage(
          imgData,
          'JPEG',
          margin,
          margin,
          pdfPageWidth,
          renderedImgHeight
        );
        pdf.save('summary.pdf');
      } else {
        // Split canvas into pages
        let remainingHeight = imgHeight;
        let position = 0;
        let pageIndex = 0;
        const overlap = Math.floor(
          20 * (canvas.width / (document.documentElement.clientWidth || 800))
        ); // adjust overlap relative to scale
        while (remainingHeight > 0) {
          const sliceHeight = Math.min(
            remainingHeight,
            Math.floor((pdfPageHeight * imgWidth) / pdfPageWidth)
          );
          const startY = Math.max(0, position - (pageIndex > 0 ? overlap : 0));
          const actualSliceHeight = Math.min(
            imgHeight - startY,
            sliceHeight + (pageIndex > 0 ? overlap : 0)
          );
          const tmpCanvas = document.createElement('canvas');
          tmpCanvas.width = imgWidth;
          tmpCanvas.height = actualSliceHeight;
          const tmpCtx = tmpCanvas.getContext('2d');
          if (tmpCtx) {
            tmpCtx.drawImage(
              canvas,
              0,
              startY,
              imgWidth,
              actualSliceHeight,
              0,
              0,
              imgWidth,
              actualSliceHeight
            );
            const tmpImgData = tmpCanvas.toDataURL('image/jpeg', 0.8);
            const tmpRenderedHeight =
              (actualSliceHeight * pdfPageWidth) / imgWidth;
            if (pageIndex > 0) pdf.addPage();
            pdf.addImage(
              tmpImgData,
              'JPEG',
              margin,
              margin,
              pdfPageWidth,
              tmpRenderedHeight
            );
          }
          position += sliceHeight;
          remainingHeight = imgHeight - position;
          pageIndex++;
        }
        pdf.save('summary.pdf');
      }

      // cleanup offscreen wrapper
      if (offscreenWrapper && offscreenWrapper.parentNode)
        offscreenWrapper.parentNode.removeChild(offscreenWrapper);

      handleClose('download');
    } catch (err) {
      console.error('Failed to generate PDF from markdown', err);
    }
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
  const [showDataTree, setShowDataTree] = React.useState<boolean>(false);
  const open = Boolean(anchorEl);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClose2 = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    // event.preventDefault();
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_SHARE_BUTTON',
      'Clicked on Share icon for viewing sharing options for the message'
    );
    setAnchorEl(event.currentTarget);
  };
  const handleClose = async (action: string) => {
    setAnchorEl(null);
    const normalizedAction = action.toUpperCase().trim().replaceAll(' ', '_');
    if (normalizedAction !== 'SHARE') {
      // For COPY and DOWNLOAD include the query (if this is a Q/A) or else the first sentence of the summary
      let extraInfo = '';
      if (normalizedAction === 'COPY' || normalizedAction === 'DOWNLOAD') {
        // Prefer explicit query text when available (msg.question or questionRefs)
        let queryText = '';
        try {
          if (msg && typeof msg.question === 'string' && msg.question.trim()) {
            queryText = msg.question.trim();
          } else if (
            questionRefs &&
            typeof (questionRefs as any).textContent === 'string' &&
            (questionRefs as any).textContent.trim()
          ) {
            queryText = (questionRefs as any).textContent.trim();
          } else if (
            questionRefs &&
            typeof (questionRefs as any).innerText === 'string' &&
            (questionRefs as any).innerText.trim()
          ) {
            queryText = (questionRefs as any).innerText.trim();
          }
        } catch (e) {
          // ignore
        }

        // If we have a query, sanitize and send it as the Query in the log
        if (queryText) {
          try {
            const renderedQ = await Promise.resolve(
              marked.parse(queryText || '')
            );
            const tmpQ = document.createElement('div');
            tmpQ.innerHTML =
              typeof renderedQ === 'string' ? renderedQ : String(renderedQ);
            queryText = (tmpQ.textContent || tmpQ.innerText || '').trim();
          } catch (e) {
            queryText = queryText
              .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
              .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
              .replace(/(```[\s\S]*?```|`[^`]*`)/g, '')
              .replace(/[>#*_~]/g, '')
              .replace(/<[^>]*>/g, '')
              .replace(/\s+/g, ' ')
              .trim();
          }
          if (queryText.length > 200)
            queryText = queryText.substring(0, 200) + '...';
          extraInfo = ` | Query: ${queryText}`;
        } else {
          // Fallback: extract first sentence from summary fields
          let summaryText = '';
          if (msg) {
            if (typeof msg.chatMessage === 'string' && msg.chatMessage.trim()) {
              summaryText = msg.chatMessage.trim();
            } else if (typeof msg.content === 'string' && msg.content.trim()) {
              summaryText = msg.content.trim();
            } else if (msg.summary && typeof msg.summary === 'string') {
              summaryText = msg.summary.trim();
            }
          }

          let firstSentence = '';
          if (summaryText) {
            const m = summaryText.match(/^[\s\S]*?[\.?!](?=\s|$)/);
            if (m && m[0]) firstSentence = m[0].trim();
            else firstSentence = summaryText.split('\n')[0].trim();
            if (firstSentence.length > 200)
              firstSentence = firstSentence.substring(0, 200) + '...';
            firstSentence = firstSentence.replace(/\s+/g, ' ');
          }

          if (firstSentence) {
            try {
              const rendered = await Promise.resolve(
                marked.parse(firstSentence || '')
              );
              const tmp = document.createElement('div');
              tmp.innerHTML =
                typeof rendered === 'string' ? rendered : String(rendered);
              firstSentence = (tmp.textContent || tmp.innerText || '').trim();
            } catch (e) {
              firstSentence = firstSentence
                .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
                .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
                .replace(/(```[\s\S]*?```|`[^`]*`)/g, '')
                .replace(/[>#*_~]/g, '')
                .replace(/<[^>]*>/g, '')
                .replace(/\s+/g, ' ')
                .trim();
            }
            if (firstSentence.length > 200)
              firstSentence = firstSentence.substring(0, 200) + '...';
            extraInfo = ` | Filters: ${firstSentence}`;
          }
        }
      }

      callLogEvent(
        'CLICKED_ON_NEW_DAILOG_SHARE_' + normalizedAction + '_BUTTON',
        'Clicked on ' +
          normalizedAction +
          ' icon from sharing options for the message' +
          extraInfo
      );
    }
  };

  const handleClick1 = (event: React.MouseEvent<HTMLElement>) => {
    // event.preventDefault();
    setAnchorEl2(event.currentTarget);
    (async () => {
      let extra = '';
      try {
        // prefer explicit query text when available
        let queryText = '';
        if (msg && typeof msg.question === 'string' && msg.question.trim()) {
          queryText = msg.question.trim();
        } else if (questionRefs && (questionRefs as any)?.textContent) {
          queryText = (questionRefs as any).textContent.trim();
        }
        if (queryText) {
          try {
            const renderedQ = await Promise.resolve(
              marked.parse(queryText || '')
            );
            const tmpQ = document.createElement('div');
            tmpQ.innerHTML =
              typeof renderedQ === 'string' ? renderedQ : String(renderedQ);
            queryText = (tmpQ.textContent || tmpQ.innerText || '').trim();
          } catch (e) {
            queryText = queryText
              .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
              .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
              .replace(/(```[\s\S]*?```|`[^`]*`)/g, '')
              .replace(/[>#*_~]/g, '')
              .replace(/<[^>]*>/g, '')
              .replace(/\s+/g, ' ')
              .trim();
          }
          if (queryText.length > 200)
            queryText = queryText.substring(0, 200) + '...';
          extra = ` | Query: ${queryText}`;
        }
      } catch (e) {
        // ignore
      }
      callLogEvent(
        'CLICKED_ON_NEW_DAILOG_VISUALIZE_BUTTON',
        'Clicked on visualize icon for showing visualization options' +
          (extra || '')
      );
    })();
  };
  const handleClose1 = (action: string) => {
    (async () => {
      setAnchorEl2(null);
      const normalized = action.toUpperCase().trim().replaceAll(' ', '_');
      let extra = '';
      try {
        let queryText = '';
        if (msg && typeof msg.question === 'string' && msg.question.trim()) {
          queryText = msg.question.trim();
        }
        if (queryText) {
          try {
            const renderedQ = await Promise.resolve(
              marked.parse(queryText || '')
            );
            const tmpQ = document.createElement('div');
            tmpQ.innerHTML =
              typeof renderedQ === 'string' ? renderedQ : String(renderedQ);
            queryText = (tmpQ.textContent || tmpQ.innerText || '').trim();
          } catch (e) {
            queryText = queryText
              .replace(/!\[[^\]]*\]\([^)]*\)/g, '')
              .replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
              .replace(/(```[\s\S]*?```|`[^`]*`)/g, '')
              .replace(/[>#*_~]/g, '')
              .replace(/<[^>]*>/g, '')
              .replace(/\s+/g, ' ')
              .trim();
          }
          if (queryText.length > 200)
            queryText = queryText.substring(0, 200) + '...';
          extra = ` | Query: ${queryText}`;
        }
      } catch (e) {
        // ignore
      }

      if (normalized !== 'VISUALIZE') {
        callLogEvent(
          'CLICKED_ON_NEW_DAILOG_VISUALIZE_' + normalized + '_BUTTON',
          'Clicked on ' +
            normalized +
            ' icon from visualization options' +
            (extra || '')
        );
      }
    })();
  };

  const handleSave = () => {
    handleSavedChats();
    callLogEvent(
      'CLICKED_ON_NEW_DAILOG_SAVE_BUTTON',
      'Clicked on Save icon for saving the message'
    );
  };
  const handleCopy = () => {
    // Helper to extract text from React nodes/arrays
    const extractTextFromNode = (node: any): string => {
      if (node === null || node === undefined) return '';
      if (typeof node === 'string' || typeof node === 'number')
        return String(node);
      if (Array.isArray(node)) return node.map(extractTextFromNode).join('\n');
      // If it's a React element, recurse into its children
      try {
        if (
          (React as any).isValidElement &&
          (React as any).isValidElement(node)
        ) {
          return extractTextFromNode(node.props?.children);
        }
      } catch (e) {
        // ignore
      }
      if (typeof node === 'object') {
        try {
          return JSON.stringify(node, null, 2);
        } catch (e) {
          return String(node);
        }
      }
      return String(node);
    };

    let messageText: string | null = null;

    // 1) Prefer explicit string fields
    if (msg) {
      if (
        typeof msg.chatMessage === 'string' &&
        msg.chatMessage.trim() !== ''
      ) {
        messageText = msg.chatMessage;
      } else if (typeof msg.content === 'string' && msg.content.trim() !== '') {
        messageText = msg.content;
      }
    }

    // 2) Try DOM ref fallback
    if (!messageText && refId) {
      try {
        let el: any = null;
        if (refId instanceof HTMLElement) el = refId;
        else if (refId && typeof refId === 'object' && 'current' in refId)
          el = refId.current;
        else if (typeof refId === 'string') el = document.querySelector(refId);
        if (el instanceof HTMLElement) {
          messageText = el.innerText || el.textContent || null;
        }
      } catch (e) {
        console.error('Error reading text from refId', e);
      }
    }

    // 3) Flatten React nodes/arrays
    if (!messageText && msg && msg.chatMessage) {
      messageText = extractTextFromNode(msg.chatMessage);
    }

    // 4) Fallback to stringify the whole msg
    if (!messageText && msg) {
      try {
        messageText = JSON.stringify(msg, null, 2);
      } catch (e) {
        messageText = String(msg);
      }
    }

    messageText = messageText || '';

    // Clean similar to PDF flow
    let cleanedMarkdown = messageText
      .replace(/â€“/g, '-')
      .replace(/âˆ’/g, '-')
      .replace(/â€”/g, '-')
      .replace(/â€™/g, "'")
      .replace(/â€"/g, '-')
      .replace(/âˆ'/g, '-')
      .replace(/â€"/g, '-')
      .replace(/â€™/g, "'")
      .replace(/Ã©/g, 'e')
      .replace(/Ã/gi, 'A')
      .replace(/&nbsp;/g, ' ')
      .replace(/\uFFFD/g, '')
      .replace(/\r\n/g, '\n')
      .replace(/\t/g, ' ')
      .replace(/[ ]{2,}/g, ' ')
      .replace(/\n{3,}/g, '\n\n')
      .replace(/([^\n])\n(###|-- \*\*|<details>)/g, '$1\n\n$2')
      .replace(/(<\/details>)\n(\*\*)/g, '$1\n\n$2')
      .replace(/\n{3,}/g, '\n\n')
      .trim();

    navigator.clipboard
      .writeText(cleanedMarkdown)
      .then(() => {
        alert('Message copied to clipboard!');
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
        alert('Failed to copy message');
      });

    handleClose('copy');
  };
  return (
    <div className={styles.btnOptions}>
      {/* <button
        disabled={false}
        onClick={() => {
          callLogEvent(
            'CLICKED_ON_DATA_TREE_MODAL_BUTTON',
            'Clicked on Data Tree for the message'
          );
          handleDataTree();
        }}
      >
        <Tooltip
          title='Open Data Tree'
          placement='top'
        >
          <img
            src={treegraph}
            alt='data tree'
          />
        </Tooltip>
      </button> */}
      <button
        disabled={false}
        onClick={() => {
          handleDownloadPdf();
        }}
      >
        <Tooltip
          title='Download the chat'
          placement='top'
        >
          <img
            src={download_icon}
            alt='download'
          />
        </Tooltip>
      </button>
      <button
        disabled={false}
        onClick={() => {
          handleCopy();
        }}
      >
        <Tooltip
          title='Copy message'
          placement='top'
        >
          <img
            src={copy_icon}
            alt='copy'
            style={{maxHeight: '16px', maxWidth: '16px'}}
          />
        </Tooltip>
      </button>
      {/* <button disabled={false} onClick={handleSave}>
        {msg.is_saved ? <Tooltip title="Saved Message" placement="top"><StarIcon style={{ maxHeight: "16px", maxWidth: "16px", color: "#005CBC" }} /></Tooltip> : <Tooltip title="Save Message" placement="top"><StarBorderIcon style={{ maxHeight: "16px", maxWidth: "16px", color: "#005CBC" }} /></Tooltip>}
      </button> */}
      <button
        onClick={handleClick1}
        hidden={msg.sender === 'summary'}
      >
        <Tooltip
          title='Visualize'
          placement='top'
        >
          <img
            src={visual_icon}
            alt='visual'
          />
        </Tooltip>
      </button>
      <Menu
        anchorEl={anchorEl2}
        open={Boolean(anchorEl2)}
        onClose={() => handleClose1('visualize')}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: isMobile ? 'center' : 'left',
        }}
      >
        <Box
          display='flex'
          style={{marginLeft: '2px', minWidth: 'auto'}}
          sx={{
            flexDirection: isMobile ? 'column' : 'row',
          }}
        >
          <Tooltip
            title='Auto Visulaize'
            placement='top'
          >
            <MenuItem
              onClick={() => {
                handleVisualization(
                  'Select and generate the best visualisation for the above data'
                );
                handleClose1('auto visulaize');
              }}
              className={styles.menugrid}
            >
              <img
                src={auto_visualize}
                style={{
                  maxHeight: '16px',
                  maxWidth: '16px',
                  marginRight: '5px',
                }}
                alt='auto_visualize'
              />
              Auto Visualise
            </MenuItem>
          </Tooltip>
          <Tooltip
            title='Visulaize using Bar Chart'
            placement='top'
          >
            <MenuItem
              onClick={() => {
                handleVisualization('Visualize as a bar chart');
                handleClose1('Bar chart');
              }}
              className={styles.menugrid}
            >
              <img
                src={bar_chart}
                style={{
                  maxHeight: '16px',
                  maxWidth: '16px',
                  marginRight: '5px',
                }}
                alt='bar_chart'
              />
              Bar Chart
            </MenuItem>
          </Tooltip>
          <Tooltip
            title='Visulaize using Pie Chart'
            placement='top'
          >
            <MenuItem
              onClick={() => {
                handleVisualization('Visualize as a Pie chart');
                handleClose1('Pie chart');
              }}
              className={styles.menugrid}
            >
              <img
                src={pie_chart}
                style={{
                  maxHeight: '16px',
                  maxWidth: '16px',
                  marginRight: '5px',
                }}
                alt='pie_chart'
              />
              Pie Chart
            </MenuItem>
          </Tooltip>
          <Tooltip
            title='Visulaize using Line Chart'
            placement='top'
          >
            <MenuItem
              onClick={() => {
                handleVisualization('Visualize as a Line chart');
                handleClose1('Line chart');
              }}
              className={styles.menugrid}
            >
              <img
                src={line_chart}
                style={{
                  maxHeight: '16px',
                  maxWidth: '16px',
                  marginRight: '5px',
                }}
                alt='line_chart'
              />
              Line Chart
            </MenuItem>
          </Tooltip>
        </Box>
      </Menu>
      <DWDModal
            show={showDataTree}
            handleClose={() => setShowDataTree(false)}
            modalName={'DataTree'}
          />

      {msg?.agent_metadata && msg?.agent_metadata.length ? (
        <SqlDrawer msg={msg} />
      ) : (
        ''
      )}
    </div>
  );
};

export default AdditionalOptions;
